import { useState, useEffect } from "react";
import {
  addNewUserManagement,
  deleteUserManagement,
  fetchUserManagementList,
  updateUserManagement,
  addNewAuthPass,
} from "../../app/redux/slices/userManagement/userManagementSlice";
import { ApiKey } from "../../api/endpoints";
import { updateUserManagementReq } from "../../api/userApi/userManagementReq";
import { showToast } from "../../app/constants/toast/toast";
import { data } from "react-router-dom";
import { useDispatch } from "react-redux";

const UserManagementPage = () => {
  const [showModalForm, setshowModalForm] = useState(false);
  const [showAuthModalForm, setShowAuthModalForm] = useState(false);
  const [dataToEdit, setdataToEdit] = useState(null);
  const [viewOnly, setviewOnly] = useState(false);

  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, seConfirmPassword] = useState("");

  const [dataLoading, setdataLoading] = useState(true);
  const roleId = JSON.parse(localStorage.getItem("RoleId"));

  const createData = async (formData) => {
    try {
      const createdBy = localStorage.getItem("Id");
      const dataBody = {
        ...formData,
        createdBy,
      };

      const res = await addNewUserManagement(dataBody);
      if (!res.data.success) {
        showToast("error");
        closeModal();
        return;
      }
      showToast(
        `An email will be sent to this(${formData.emailAddress}) address`,
        "success"
      );
      closeModal();
      setdataLoading(true);
    } catch (error) {
      closeModal();
    }
  };

  const updateData = async (formData) => {
    try {
      const dataBody = {
        id: formData?.id || 1,
        name: formData?.name || "",
        emailAddress: formData?.emailAddress || "",
        roleId: formData?.roleId || 0,
        isProjectManager:
          formData?.roleId === "2" ? formData?.isProjectManager : false,
        modifiedBy: localStorage.getItem("UserName"),
      };
      if (
        formData?.id === parseInt(localStorage.getItem("Id")) &&
        formData?.roleId !== parseInt(localStorage.getItem("RoleId"))
      ) {
        showToast("Users cannot update their own roles", "error");
        closeModal();
        return;
      }
      await updateUserManagementReq(dataBody);
      closeModal();
    } catch (error) {
      closeModal();
    }
  };

  const closeModal = () => {
    setdataToEdit(null);
    setshowModalForm(false);
    setShowAuthModalForm(false);
    setviewOnly(false);
    setNewPassword("");
    seConfirmPassword("");
  };

  console.log(localStorage.getItem("token"));
  return (
    <div className="main-content p-4 position-static">
      <div>
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ marginBottom: "14px", width: "100%" }}>
            <label style={{ fontWeight: "500" }}>New Password</label>
            <input
              type="text"
              placeholder="New Password"
              value={NewPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                marginBottom: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>
        </div>

        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ marginBottom: "14px", width: "100%" }}>
            <label style={{ fontWeight: "500" }}>Confirm Password</label>
            <input
              type="text"
              placeholder="Confirm Password"
              value={ConfirmPassword}
              onChange={(e) => seConfirmPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                marginBottom: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManagementPage;
